import React, { useState, useEffect } from 'react';

const Contact = ({ isVisible, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    serviceType: 'promo'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Handle escape key to close modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isVisible) {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isVisible, onClose]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Create email content
      const emailSubject = `New Contact Form Submission from ${formData.name}`;
      const emailBody = `
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company || 'Not provided'}
Service Interest: ${formData.serviceType}
Message: ${formData.message}
`;
      
      // Create mailto link
      const mailtoLink = `mailto:Kraai@jfkproductions.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
      
      // Open email client
      window.location.href = mailtoLink;
      
      // Show success message
      setSubmitStatus('success');
      setIsSubmitting(false);
      setFormData({
        name: '',
        email: '',
        company: '',
        message: '',
        serviceType: 'promo'
      });
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('error');
      setIsSubmitting(false);
    }
  };

  if (!isVisible) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="contact-overlay" onClick={handleOverlayClick}>
      <div className="contact-container">
        <button className="contact-close" onClick={onClose}>
          ×
        </button>
        
        <div className="contact-content">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>Ready to bring your vision to life? Let's discuss your project and create something extraordinary together.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <h3>Email</h3>
                <a href="mailto:Kraai@jfkproductions.com">Kraai@jfkproductions.com</a>
              </div>
              
              <div className="contact-item">
                <h3>Location</h3>
                <p>Netherlands</p>
              </div>
              
              <div className="contact-item">
                <h3>Follow Us</h3>
                <div className="social-links">
                  <a href="https://instagram.com/jfkproductions" target="_blank" rel="noopener noreferrer">Instagram</a>
                  <a href="https://linkedin.com/company/jfkproductions" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                  <a href="https://facebook.com/jfkproductions" target="_blank" rel="noopener noreferrer">Facebook</a>
                  <a href="https://youtube.com/jfkproductions" target="_blank" rel="noopener noreferrer">YouTube</a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-form-section">
            <h3>Send us a message</h3>
            
            {submitStatus === 'success' && (
              <div className="success-message">
                <p>Thank you for your message! Your email client should open with the message ready to send.</p>
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="error-message">
                <p>There was an error processing your request. Please try again or contact us directly at Kraai@jfkproductions.com</p>
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="serviceType">Service Interest</label>
                <select
                  id="serviceType"
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleInputChange}
                >
                  <option value="promo">Promo Videos</option>
                  <option value="music">Music Videos</option>
                  <option value="corporate">Corporate Films</option>
                  <option value="film">Film Production</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="5"
                  placeholder="Tell us about your project..."
                  required
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;